import * as Globalize from 'globalize';
import {LocaleString} from '../ExternalModulesShim';
var merge = function(obj1, obj2) {
  var obj3 = {};
  for(var attrname in obj1){obj3[attrname] = obj1[attrname]; }
  for(var attrname in obj2){obj3[attrname] = obj2[attrname]; }
  return obj3;
}
var dict = {
  "Unknown": "Unknown",
  "And": "AND",
  "Authenticating": "Authenticating {0}...",
  "Clear": "Clear {0}",
  "CompleteQuery": "Complete Query",
  "Exclude": "Exclude {0}",
  "EnterTag": "Add Tag",
  "Next": "Next",
  "Last": "Last",
  "Link": "Link",
  "Or": "OR",
  "Previous": "Previous",
  "QueryDidntMatchAnyDocuments": "Your query did not match any documents.",
  "QueryException": "Your query has an error: {0}.",
  "Me": "Me",
  "Remove": "Remove",
  "Search": "Search",
  "SearchFor": "Search for {0}",
  "ShareQuery": "Share Query",
  "Preferences": "Preferences",
  "LinkOpeningSettings": "Link Opening Settings",
  "Reauthenticate": "Reauthenticate {0}",
  "ResultsFilteringExpression": "Results Filtering Expressions",
  "FiltersInYourPreferences": "Filters in your preferences",
  "Create": "Create",
  "SearchIn": "Search in {0}",
  "Seconds": "in {0} second<pl>s</pl>",
  "ShowingResultsOf": "Result<pl>s</pl> {0}<pl>-{1}</pl> of {2}",
  "SwitchTo": "Switch to {0}",
  "Unexclude": "Unexclude {0}",
  "ClearAllFilters": "Clear All Filters",
  "SkipLogin": "Skip login",
  "LoginInProgress": "Login in progress, please wait ...",
  "Login": "Log In",
  "GetStarted": "Get Started",
  "More": "More",
  "NMore": "{0} more...",
  "Less": "Fewer",
  "Settings": "Settings",
  "Score": "Score",
  "ScoreDescription": "The score is computed from the number of occurrences as well as from the position in the result set.",
  "Occurrences": "Occurrences",
  "OccurrencesDescription": "Sort by number of occurrences, with values having the highest number appearing first.",
  "Label": "Label",
  "Of": "of",
  "LabelDescription": "Sort alphabetically on the field values.",
  "Value": "Value",
  "ValueDescription": "Sort on the values of the first computed field",
  "AlphaAscending": "Value Ascending",
  "AlphaDescending": "Value Descending",
  "ChiSquare": "Chi Square",
  "Nosort": "No Sort",
  "NosortDescription": "Do not sort the values. The values will be returned in a random order.",
  "RelativeFrequency": "Relative Frequency",
  "RelativeFrequencyDescription": "Sort based on the relative frequency of values. Less common values will appear higher.",
  "DateDistribution": "Date distribution",
  "Custom": "Custom",
  "CustomDescription": "Sort based on a custom order",
  "ComputedField": "Computed Field",
  "Ascending": "Ascending",
  "Descending": "Descending",
  "noResultFor": "No results for {0}",
  "autoCorrectedQueryTo": "Query was automatically corrected to {0}",
  "didYouMean": "Did you mean: {0}",
  "SuggestedResults": "Suggested Results",
  "SuggestedQueries": "Suggested Queries",
  "MostRelevantItems": "Most relevant items:",
  "AllItems": "All items:",
  "ShowLess": "Show less",
  "ShowMore": "Show more",
  "HideFacet": "Hide Facet",
  "ShowFacet": "Show Facet",
  "AndOthers": "and {0} other<pl>s</pl>",
  "Others": "{0} other<pl>s</pl>",
  "MostRelevantPosts": "Most Relevant Posts:",
  "CompleteThread": "Complete Thread:",
  "ShowCompleteThread": "Show Complete Thread",
  "ShowOnlyTopMatchingPosts": "Show Only Top Matching Posts",
  "MostRelevantReplies": "Most Relevant Replies:",
  "AllConversation": "All Conversation:",
  "ShowAllConversation": "Show All Conversation",
  "ShowAllReplies": "Show All Replies",
  "ShowOnlyMostRelevantReplies": "Show Only Most Relevant Replies",
  "Close": "Close",
  "Open": "Open",
  "OpenInOutlookWhenPossible": "Open in Outlook (when possible)",
  "AlwaysOpenInNewWindow": "Always open results in new window",
  "Quickview": "Quick View",
  "NoQuickview": "The Quick View for this document is unavailable",
  "ErrorReport": "Error Report",
  "OopsError": "Something went wrong.",
  "ProblemPersists": "If the problem persists contact the administrator.",
  "GoBack": "Go Back",
  "Reset": "Reset",
  "Retry": "Retry",
  "MoreInfo": "More Information",
  "Username": "Username",
  "Password": "Password",
  "PostedBy": "Posted by",
  "CannotConnect": "Cannot connect to the server address.",
  "BadUserPass": "Password does not match with username.",
  "PleaseEnterYourCredentials": "Please enter your credentials for {0}.",
  "PleaseEnterYourSearchPage": "Please enter your search page URL",
  "Collapse": "Collapse",
  "Collapsable": "Collapsible",
  "Expand": "Expand",
  "Today": "Today",
  "Yesterday": "Yesterday",
  "Tomorrow": "Tomorrow",
  "Duration": "Duration: {0}",
  "IndexDuration": "Index Duration: {0}",
  "ProxyDuration": "Proxy Duration: {0}",
  "ClientDuration": "Client Duration: {0}",
  "Unavailable": "Unavailable",
  "Reply": "Reply",
  "ReplyAll": "Reply All",
  "Forward": "Forward",
  "From": "From",
  "Caption": "Caption",
  "Expression": "Expression",
  "Tab": "Tab",
  "Tabs": "Tabs",
  "EnterExpressionName": "Enter expression name",
  "EnterExpressionToFilterWith": "Enter expression to filter results with",
  "SelectTab": "Select Tab",
  "SelectAll": "Select All",
  "PageUrl": "Search page URL",
  "ErrorSavingToDevice": "Error while saving the information to your device",
  "ErrorReadingFromDevice": "Error while reading the information from your device",
  "AppIntro": "Speak with a product specialist who can answer your questions about Coveo and help you decide which Coveo solution is right for you. Or, try a live demo !",
  "TryDemo": "Try the demo",
  "ContactUs": "Contact us",
  "NewToCoveo": "New to Coveo?",
  "LetUsHelpGetStarted": "Let us help you get started",
  "LikesThis": "{0} like<sn>s</sn> this.",
  "CannotConnectSearchPage": "Cannot connect to your search page",
  "AreYouSureDeleteFilter": "Are you sure you want to delete the filter {0} with the expression {1}",
  "OnlineHelp": "Online Help",
  "Done": "Done",
  "SaveFacetState": "Save this facet state",
  "ClearFacetState": "Clear facet state",
  "DisplayingTheOnlyMessage": "Displaying the only message in this conversation",
  "NoNetworkConnection": "No network connection",
  "UnknownConnection": "Unknown connection",
  "EthernetConnection": "Ethernet connection",
  "WiFi": "WiFi connection",
  "CELL": "Cellular connection",
  "CELL_2G": "Cellular 2G connection",
  "CELL_3G": "Cellular 3G connection",
  "CELL_4G": "Cellular 4G connection",
  "Relevance": "Relevance",
  "Date": "Date",
  "Amount": "Amount",
  "QueryExceptionNoException": "No exception",
  "QueryExceptionInvalidSyntax": "Invalid syntax",
  "QueryExceptionInvalidCustomField": "Invalid custom field",
  "QueryExceptionInvalidDate": "Invalid date",
  "QueryExceptionInvalidExactPhrase": "Invalid exact phrase",
  "QueryExceptionInvalidDateOp": "Invalid date operator",
  "QueryExceptionInvalidNear": "Invalid NEAR operator",
  "QueryExceptionInvalidWeightedNear": "Invalid weighted NEAR",
  "QueryExceptionInvalidTerm": "Invalid term",
  "QueryExceptionTooManyTerms": "Too many terms",
  "QueryExceptionWildcardTooGeneral": "Wildcard too general",
  "QueryExceptionInvalidSortField": "Invalid sort field",
  "QueryExceptionInvalidSmallStringOp": "Invalid small string operator",
  "QueryExceptionRequestedResultsMax": "Requested results maximum",
  "QueryExceptionAggregatedMirrorDead": "Aggregated mirror is offline",
  "QueryExceptionAggregatedMirrorQueryTimeOut": "Aggregated mirror query timeout",
  "QueryExceptionAggregatedMirrorInvalidBuildNumber": "Aggregated mirror invalid build number",
  "QueryExceptionAggregatedMirrorCannotConnect": "Aggregated mirror cannot connect",
  "QueryExceptionNotEnoughLeadingCharsWildcard": "Not enough leading character wildcard",
  "QueryExceptionSecurityInverterNotFound": "Security inverter not found",
  "QueryExceptionSecurityInverterAccessDenied": "Security inverter access denied",
  "QueryExceptionAggregatedMirrorCannotImpersonate": "Aggregated mirror cannot impersonate",
  "QueryExceptionUnexpected": "Unexpected",
  "QueryExceptionAccessDenied": "Access denied",
  "QueryExceptionSuperUserTokenInvalid": "Super user token invalid",
  "QueryExceptionSuperUserTokenExpired": "Super user token is expired",
  "QueryExceptionLicenseQueriesExpired": "Queries license expired",
  "QueryExceptionLicenseSuperUserTokenNotSupported": "License super user token not supported",
  "QueryExceptionInvalidSession": "Invalid session",
  "QueryExceptionInvalidDocument": "Invalid document",
  "QueryExceptionSearchDisabled": "Search disabled",
  "FileType": "File type",
  "ShowAttachment": "Show attachment",
  "OnFeed": "on {0}'s feed.",
  "Author": "Author",
  "NoTitle": "No title",
  "CurrentSelections": "Current selections",
  "AllContent": "All content",
  "CancelLastAction": "Cancel last action",
  "SearchTips": "Search tips",
  "CheckSpelling": "Check the spelling of your keywords.",
  "TryUsingFewerKeywords": "Try using fewer, different or more general keywords.",
  "SelectFewerFilters": "Select fewer filters to broaden your search.",
  "Document": "Document",
  "Time": "Time",
  "StartDate": "Start Date",
  "StartTime": "Start Time",
  "DurationTitle": "Duration",
  "UserQuery": "User query",
  "ShowUserActions": "Show User Actions",
  "NoData": "No data available",
  "EventType": "Event type",
  "GoToFullSearch": "Full search",
  "GoToEdition": "Customize Panel",
  "RemoveContext": "Remove context",
  "BoxAttachToCase": "Attach to case",
  "AttachToCase": "Attach to case",
  "Attach": "Attach",
  "Attached": "Attached",
  "Detach": "Detach",
  "Details": "Details",
  "AdditionalFilters": "Additional filters",
  "SelectNonContextualSearch": "Remove the context from the current record to broaden your search",
  "CopyPasteToSupport": "Copy paste this message to Coveo Support team for more information.",
  "FollowQueryDescription": "Alert me for changes to the search results of this query.",
  "SearchAlerts_Panel": "Manage Alerts",
  "SearchAlerts_PanelDescription": "View and manage your search alerts.",
  "SearchAlerts_PanelNoSearchAlerts": "You have no subscriptions.",
  "SearchAlerts_Fail": "The Search Alerts service is currently unavailable.",
  "SearchAlerts_Type": "Type",
  "SearchAlerts_Content": "Content",
  "SearchAlerts_Actions": "Action",
  "EmptyQuery": "&lt;empty&gt;",
  "SearchAlerts_Type_followQuery": "Query",
  "SearchAlerts_Type_followDocument": "Item",
  "SearchAlerts_unFollowing": "Stop Following",
  "SearchAlerts_follow": "Follow",
  "SearchAlerts_followed": "Followed",
  "SearchAlerts_followQuery": "Follow Query",
  "Subscription_StopFollowingQuery": "Stop Following Query",
  "SearchAlerts_Frequency": "When",
  "SubscriptionsManageSubscriptions": "Manage Alerts",
  "SubscriptionsMessageFollowQuery": "You will receive alerts when the query <b>{0}</b> returns new or updated items.",
  "SubscriptionsMessageFollow": "You will receive alerts for changes to the item <b>{0}</b>.",
  "Expiration": "Expiration",
  "Monthly": "Monthly",
  "Daily": "Daily",
  "Monday": "Monday",
  "Tuesday": "Tuesday",
  "Wednesday": "Wednesday",
  "Thursday": "Thursday",
  "Friday": "Friday",
  "Saturday": "Saturday",
  "Sunday": "Sunday",
  "NextDay": "Next {0}",
  "LastDay": "Last {0}",
  "StartTypingCaseForSuggestions": "Describe your problem to see possible solutions",
  "ExportToExcel": "Export to Excel",
  "ExportToExcelDescription": "Export search results to Excel",
  "CaseCreationNoResults": "No recommended solutions were found",
  "SortBy": "Sort by",
  "BoxCreateArticle": "Create Article",
  "Facets": "Facets",
  "AdvancedSearch": "Advanced Search",
  "Keywords": "Keywords",
  "AllTheseWords": "All these words",
  "ExactPhrase": "This exact phrase",
  "AnyOfTheseWords": "Any of these words",
  "NoneOfTheseWords": "None of these words",
  "Anytime": "Anytime",
  "InTheLast": "In the last",
  "Days": "days",
  "Months": "months",
  "Between": "Between",
  "Language": "Language",
  "Size": "Size",
  "AtLeast": "at least",
  "AtMost": "at most",
  "Contains": "contains",
  "DoesNotContain": "does not contain",
  "Matches": "matches",
  "Bytes": "bytes",
  "list": "List",
  "card": "Card",
  "table": "Table",
  "ResultLinks": "Result links",
  "EnableQuerySyntax": "Enable query syntax",
  "On": "On",
  "Off": "Off",
  "Automatic": "Automatic",
  "ResultsPerPage": "Results per page",
  "objecttype_people": "People",
  "objecttype_message": "Message",
  "objecttype_feed": "RSS Feed",
  "objecttype_thread": "Thread",
  "objecttype_file": "File",
  "objecttype_board": "Board",
  "objecttype_category": "Category",
  "objecttype_account": "Account",
  "objecttype_annotation": "Note",
  "objecttype_campaign": "Campaign",
  "objecttype_case": "Case",
  "objecttype_contentversion": "Salesforce File",
  "objecttype_contact": "Contact",
  "objecttype_contract": "Contract",
  "objecttype_event": "Event",
  "objecttype_email": "Email",
  "objecttype_goal": "Goal",
  "objecttype_incident": "Case",
  "objecttype_invoice": "Invoice",
  "objecttype_lead": "Lead",
  "objecttype_list": "Marketing List",
  "objecttype_solution": "Solution",
  "objecttype_task": "Task",
  "objecttype_user": "User",
  "objecttype_attachment": "Attachment",
  "objecttype_casecomment": "Case Comment",
  "objecttype_opportunity": "Opportunity",
  "objecttype_opportunityproduct": "Opportunity Product",
  "objecttype_feeditem": "Chatter",
  "objecttype_feedcomment": "Chatter",
  "objecttype_note": "Note",
  "objecttype_product": "Product",
  "objecttype_partner": "Partner",
  "objecttype_queueitem": "Queue Item",
  "objecttype_quote": "Quote",
  "objecttype_salesliterature": "Sales Literature",
  "objecttype_salesorder": "Sales Order",
  "objecttype_service": "Service",
  "objecttype_socialprofile": "Social Profile",
  "objecttype_kbdocumentation": "Documentation",
  "objecttype_kbtechnicalarticle": "Documentation",
  "objecttype_kbsolution": "Solution",
  "objecttype_kbknowledgearticle": "Knowledge Article",
  "objecttype_kbattachment": "Attachment",
  "objecttype_kbarticle": "Article",
  "objecttype_kbarticlecomment": "Article Comment",
  "objecttype_knowledgearticle": "Knowledge Article",
  "filetype_box user": "Box User",
  "filetype_html": "HTML File",
  "filetype_wiki": "Wiki",
  "filetype_webscraperwebpage": "Web Page",
  "filetype_image": "Image",
  "filetype_folder": "Folder",
  "filetype_txt": "Text",
  "filetype_zip": "Zip File",
  "filetype_olefile": "OLE file",
  "filetype_gmailmessage": "Gmail Message",
  "filetype_pdf": "PDF File",
  "filetype_swf": "Flash File",
  "filetype_xml": "XML File",
  "filetype_vsd": "Visio",
  "filetype_svg": "SVG",
  "filetype_svm": "Open Office",
  "filetype_rssitem": "RSS feed",
  "filetype_doc": "Document",
  "filetype_docx": "Microsoft Word Document",
  "filetype_xls": "Spreadsheet Document",
  "filetype_ppt": "Presentation Document",
  "filetype_video": "Video",
  "filetype_youtube": "YouTube video",
  "filetype_saleforceitem": "Salesforce",
  "filetype_dynamicscrmitem": "Dynamics CRM",
  "filetype_salesforceitem": "Salesforce",
  "filetype_odt": "Open Text Document",
  "filetype_cfpage": "Confluence Page",
  "filetype_cfcomment": "Confluence Comment",
  "filetype_cfspace": "Confluence Space",
  "filetype_cfblogentry": "Confluence Blog Entry",
  "filetype_confluencespace": "Confluence Space",
  "filetype_exchangemessage": "Message",
  "filetype_exchangeappointment": "Appointment",
  "filetype_exchangenote": "Note",
  "filetype_exchangetask": "Task",
  "filetype_exchangeperson": "Exchange User",
  "filetype_activedirperson": "Active Directory User",
  "filetype_exchangeactivity": "Activity",
  "filetype_exchangecalendarmessage": "Calendar Message",
  "filetype_exchangedocument": "Exchange Document",
  "filetype_exchangedsn": "DSN",
  "filetype_exchangefreebusy": "Free/Busy",
  "filetype_exchangegroup": "Group",
  "filetype_exchangerssfeed": "RSS Feed",
  "filetype_exchangejunkmessage": "Junk Email",
  "filetype_exchangeofficecom": "Communications",
  "filetype_lithiummessage": "Lithium Message",
  "filetype_lithiumthread": "Lithium Thread",
  "filetype_lithiumboard": "Lithium Board",
  "filetype_lithiumcategory": "Lithium Category",
  "filetype_lithiumcommunity": "Lithium Community",
  "filetype_spportal": "Portal",
  "filetype_spsite": "Site",
  "filetype_spuserprofile": "SharePoint User",
  "filetype_sparea": "Area",
  "filetype_spannouncement": "Announcement",
  "filetype_spannouncementlist": "Announcements",
  "filetype_spcontact": "Contact",
  "filetype_spcontactlist": "Contacts",
  "filetype_spcustomlist": "Custom Lists",
  "filetype_spdiscussionboard": "Discussion Board",
  "filetype_spdiscussionboardlist": "Discussion Boards",
  "filetype_spdocumentlibrarylist": "Document Library",
  "filetype_spevent": "Event",
  "filetype_speventlist": "Events",
  "filetype_spformlibrarylist": "Form Library",
  "filetype_spissue": "Issue",
  "filetype_spissuelist": "Issues",
  "filetype_splink": "Link",
  "filetype_splinklist": "Links",
  "filetype_sppicturelibrarylist": "Picture Library",
  "filetype_spsurvey": "Survey",
  "filetype_spsurveylist": "Surveys",
  "filetype_sptask": "Task",
  "filetype_sptasklist": "Tasks",
  "filetype_spagenda": "Agenda",
  "filetype_spagendalist": "Ordres du jour",
  "filetype_spattendee": "Attendee",
  "filetype_spattendeelist": "Attendees",
  "filetype_spcustomgridlist": "Custom Grids",
  "filetype_spdecision": "Decision",
  "filetype_spdecisionlist": "Decisions",
  "filetype_spobjective": "Objective",
  "filetype_spobjectivelist": "Objectives",
  "filetype_sptextbox": "Textbox",
  "filetype_sptextboxlist": "Textbox list",
  "filetype_spthingstobring": "Thing To Bring",
  "filetype_spthingstobringlist": "Things To Bring",
  "filetype_sparealisting": "Area Listing",
  "filetype_spmeetingserie": "Meeting series",
  "filetype_spmeetingserielist": "Meeting Series List",
  "filetype_spsitedirectory": "Site Directory Item",
  "filetype_spsitedirectorylist": "Site Directory",
  "filetype_spdatasource": "Data Source",
  "filetype_spdatasourcelist": "Data Source List",
  "filetype_splisttemplatecataloglist": "List Template Gallery",
  "filetype_spwebpartcataloglist": "WebPart Gallery",
  "filetype_spwebtemplatecataloglist": "Site Template Gallery",
  "filetype_spworkspacepagelist": "Workspace Pages",
  "filetype_spunknownlist": "Custom List",
  "filetype_spadministratortask": "Administrator Task",
  "filetype_spadministratortasklist": "Administrator Tasks",
  "filetype_spareadocumentlibrarylist": "Area Document Library",
  "filetype_spblogcategory": "Blog Category",
  "filetype_spblogcategorylist": "Blog Categories",
  "filetype_spblogcomment": "Blog Comment",
  "filetype_spblogcommentlist": "Blog Comments",
  "filetype_spblogpost": "Blog Post",
  "filetype_spblogpostlist": "Blog Posts",
  "filetype_spdataconnectionlibrarylist": "Data Connection Library",
  "filetype_spdistributiongroup": "Distribution Group",
  "filetype_spdistributiongrouplist": "Distribution Groups",
  "filetype_spipfslist": "InfoPath Forms Servers",
  "filetype_spkeyperformanceindicator": "Key Performance Indicator",
  "filetype_spkeyperformanceindicatorlist": "Key Performance Indicators",
  "filetype_splanguagesandtranslator": "Languages and Translator",
  "filetype_splanguagesandtranslatorlist": "Languages and Translators",
  "filetype_spmasterpagescataloglist": "Master Page Gallery",
  "filetype_spnocodeworkflowlibrarylist": "No-code Workflow Libraries",
  "filetype_spprojecttask": "Project Task",
  "filetype_spprojecttasklist": "Project Tasks",
  "filetype_sppublishingpageslibrarylist": "Page Library",
  "filetype_spreportdocumentlibrarylist": "Report Document Library",
  "filetype_spreportlibrarylist": "Report Library",
  "filetype_spslidelibrarylist": "Slide Library",
  "filetype_sptab": "Tabs",
  "filetype_sptablist": "Tabs List",
  "filetype_sptranslationmanagementlibrarylist": "Translation Management Library",
  "filetype_spuserinformation": "User Information",
  "filetype_spuserinformationlist": "User Information List",
  "filetype_spwikipagelibrarylist": "Wiki Page Library",
  "filetype_spworkflowhistory": "Workflow History",
  "filetype_spworkflowhistorylist": "Workflow History List",
  "filetype_spworkflowprocess": "Custom Workflow Process",
  "filetype_spworkflowprocesslist": "Custom Workflow Processes",
  "filetype_sppublishingimageslibrarylist": "Publishing Image Library",
  "filetype_spcirculation": "Circulation",
  "filetype_spcirculationlist": "Circulations",
  "filetype_spdashboardslibrarylist": "Dashboards Library",
  "filetype_spdataconnectionforperformancepointlibrarylist": "PerformancePoint Data Connection Library",
  "filetype_sphealthreport": "Health Report",
  "filetype_sphealthreportlist": "Health Reports",
  "filetype_sphealthrule": "Health Rule",
  "filetype_sphealthrulelist": "Health Rules",
  "filetype_spimedictionary": "IME Dictionary",
  "filetype_spimedictionarylist": "IME Dictionaries",
  "filetype_spperformancepointcontent": "PerformancePoint Content",
  "filetype_spperformancepointcontentlist": "PerformancePoint Contents",
  "filetype_spphonecallmemo": "Phone Call Memo",
  "filetype_spphonecallmemolist": "Phone Call Memos",
  "filetype_sprecordlibrarylist": "Record Library",
  "filetype_spresource": "Resource",
  "filetype_spresourcelist": "Resources",
  "filetype_spprocessdiagramslibrarylist": "Process Diagram Library",
  "filetype_spsitethemeslibrarylist": "Site Theme Library",
  "filetype_spsolutionslibrarylist": "Solution Library",
  "filetype_spwfpublibrarylist": "WFPUB Library",
  "filetype_spwhereabout": "Whereabout",
  "filetype_spwhereaboutlist": "Whereabouts",
  "filetype_spdocumentlink": "Link to a Document",
  "filetype_spdocumentset": "Document Set",
  "filetype_spmicrofeedpost": "Microfeed Post",
  "filetype_spmicrofeedlist": "Microfeed",
  "filetype_splistfolder": "List Folder",
  "filetype_youtubevideo": "YouTube video",
  "filetype_youtubeplaylistitem": "YouTube playlist item",
}
export function defaultLanguage() {
  var locales = String["locales"] || (String["locales"] = {});
  locales["en"] = merge(locales["en"], dict);
  String["toLocaleString"].call(this, { "en": dict });
  String["locale"] = "en";
  String["defaultLocale"] = "en";
  Globalize.culture("en")
}
export function setLanguageAfterPageLoaded() {
  var locales = String["locales"] || (String["locales"] = {});
  locales["en"] = merge(locales["en"], dict);
  String["toLocaleString"].call(this, { "en": dict });
  String["locale"] = "en";
  String["defaultLocale"] = "en";
  Globalize.culture("en")
}



/** WEBPACK FOOTER **
 ** ./src/strings/DefaultLanguage.ts
 **/